import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import colors from '../styles/colors';

const LanguageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
  padding: 1rem;
  background: ${colors.background.light};
  border-radius: 12px;
  border: 2px solid ${colors.primary.green}20;
`;

const LanguageLabel = styled.span`
  font-weight: 600;
  color: ${colors.text.primary};
  font-size: 0.9rem;
`;

const LanguageButtons = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const LanguageButton = styled.button`
  padding: 0.5rem 1rem;
  border: 2px solid ${props => props.active ? colors.primary.green : colors.primary.green}40;
  background: ${props => props.active ? colors.primary.green : 'transparent'};
  color: ${props => props.active ? 'white' : colors.primary.green};
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: ${props => props.active ? colors.primary.green : colors.primary.green}20;
    transform: translateY(-1px);
  }
`;

const EnglishText = styled.span`
  font-size: 0.75rem;
  color: ${colors.text.secondary}60;
  font-style: italic;
  margin-left: 0.5rem;
`;

const MenuLanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  const getLanguageName = (lang) => {
    const names = {
      'pt': 'PT',
      'it': 'IT',
      'en': 'EN'
    };
    return names[lang] || lang;
  };

  return (
    <LanguageContainer>
      <LanguageLabel>Idioma:</LanguageLabel>
      <LanguageButtons>
        <LanguageButton 
          active={i18n.language === 'pt'} 
          onClick={() => changeLanguage('pt')}
        >
          {getLanguageName('pt')}
        </LanguageButton>
        <LanguageButton 
          active={i18n.language === 'it'} 
          onClick={() => changeLanguage('it')}
        >
          {getLanguageName('it')}
        </LanguageButton>
      </LanguageButtons>
      <EnglishText>
        EN disponível
      </EnglishText>
    </LanguageContainer>
  );
};

export default MenuLanguageSwitcher;
